import { CompletedSurvey } from "../types/CompletedSurveysType";
import { getFormattedDate } from "@utils/helperFunctions";

const formatCompletedSurveys = (data) => {
  const formattedSurveys = data?.data
    ?.filter(
      (survey) =>
        survey.attributes.status == "completed" ||
        survey.attributes.status == "applied" ||
        survey.attributes.status == "revised"
    )
    .map((survey, i) => {
      //check if survey has a related project
      const relatedProjectId = survey.relationships.project?.data?.id;
      let relatedProject;
      if (relatedProjectId) {
        const project = data.included.find(
          (project) => project.id == relatedProjectId
        );
        if (project) {
          relatedProject = {
            id: project.id,
            name: project.attributes["project-name"],
          };
        }
      }

      //get tags from related questionnaire
      const relatedQuestionnaireId =
        survey.relationships.questionnaire.data?.id;
      let relatedTags;
      if (relatedQuestionnaireId) {
        let questionnaire = data?.included?.find(
          (q) => q.id == relatedQuestionnaireId
        );

        let tagList = questionnaire?.attributes?.["tag-list"];
        tagList?.length > 0 ? (relatedTags = tagList) : null;
      }
      const surveyData: CompletedSurvey = {
        id: survey.id,
        checked: false,
        attributes: {
          name: survey.attributes.name,
          project: relatedProject ? relatedProject.name : "",
          completedBy: survey.attributes["contact-name"]
            ? survey.attributes["contact-name"]
            : "",
          completedOn: survey.attributes["updated-at"]
            ? getFormattedDate(new Date(survey.attributes["updated-at"]))
            : "",
          tags: relatedTags ? relatedTags : [],
          questionnaireId: relatedQuestionnaireId,
          projectId: relatedProject ? relatedProject.id : "",
        },
      };

      return surveyData;
    });

  return {
    data: formattedSurveys,
    meta: { ...data?.meta, "record-count": formattedSurveys.length },
    included: data.included,
  };
};

export default formatCompletedSurveys;
